import React, { useEffect, useState } from 'react';
import useStyles from "../style";
import {renderErrorCreatePool} from "../../../utils/validate";

function CustomNetworkTitle(props: any) {
  const classes = useStyles();
  const {
    register, errors,
    poolDetail, watch, setValue, getTokenInforDetail
  } = props;
  const renderError = renderErrorCreatePool;

  useEffect(() => {
    register("custom_network_title");
  }, [register]);

  return (
    <>
      <div className={classes.formControl}
      style={{
        marginTop:'0px'
      }}
      >
        <label className={classes.formControlLabel}>Custom Network Title</label>
        <input
          type="text"
          name='custom_network_title'
          defaultValue={poolDetail?.custom_network_title}
          ref={register({ required: true })}
          className={classes.formControlInput}
          
        />

        <p className={classes.formErrorMessage}>
          {
            renderError(errors, 'custom_network_title')
          }
        </p>
      </div>
    </>
  );
}

export default CustomNetworkTitle;
